export enum PermissionEnum {
	RequirementControlCanSee = 'requirement-control:can-see',
  RequirementControlCanEdit = 'requirement-control:can-edit',

  TrainingControlCanSee = 'training-control:can-see',
  TrainingControlCanUpload = 'training-control:can-upload',

  OrganizationChartCanSee = 'organization-chart:can-see',
  OrganizationChartCanEdit = 'organization-chart:can-edit',

  FixedAllocationsCanSee = 'fixed-allocations:can-see',
};
